var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThisApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 2H12.6C14.8402 2 15.9603 2 16.816 2.43597C17.5686 2.81947 18.1805 3.43139 18.564 4.18404C19 5.03969 19 6.15979 19 8.4V15.6C19 17.8402 19 18.9603 18.564 19.816C18.1805 20.5686 17.5686 21.1805 16.816 21.564C15.9603 22 14.8402 22 12.6 22H11.4C9.15979 22 8.03969 22 7.18404 21.564C6.43139 21.1805 5.81947 20.5686 5.43597 19.816C5 18.9603 5 17.8402 5 15.6V8.4C5 6.15979 5 5.03969 5.43597 4.18404C5.81947 3.43139 6.43139 2.81947 7.18404 2.43597C8.03969 2 9.15979 2 11.4 2ZM12.1381 16.25C11.3715 16.25 10.75 16.8715 10.75 17.6381C10.75 18.4047 11.3715 19.0262 12.1381 19.0262C12.9047 19.0262 13.5262 18.4047 13.5262 17.6381C13.5262 16.8715 12.9047 16.25 12.1381 16.25Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThisApp);
export default __webpack_public_path__ + "static/media/this_app.06941ab3043551bf1a63860eb3422dc0.svg";
export { ForwardRef as ReactComponent };